// extracted by mini-css-extract-plugin
module.exports = {"select":"DropDown_select__3qMqm"};